// The keys react-hook-form puts beside a message on an error node.
const ERROR_NODE_KEYS = ['message', 'type', 'types', 'ref', 'root'];

/*
    Every message in the error tree, flattened and deduplicated.

    The save panel lists these rather than telling an admin to look for a red field. Two of the
    schema's rules have no field of their own to turn red: a duplicate lesson belongs to a chapter's
    lesson list, and a summary with no lessons belongs to its chip list. The shared TextField also
    only reddens a field the admin has touched, so a course that was already invalid when it loaded
    shows nothing.
*/
export function validationMessages(errors: Record<string, unknown>): string[] {
    const messages: string[] = [];

    function walk(node: unknown) {
        if (!node || typeof node !== 'object') return;

        const message = (node as { message?: unknown }).message;
        if (typeof message === 'string' && message) messages.push(message);

        Object.entries(node).forEach(([key, value]) => {
            if (!ERROR_NODE_KEYS.includes(key)) walk(value);
        });
    }

    walk(errors);

    // One chapter without a title reads the same as four of them.
    return [...new Set(messages)];
}
